// eslint-disable-next-line
import { useState } from 'react';
import axios from 'axios';
import classes from './HomePage.module.css';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';


const HomePage = (props) => {
    const [email, setEmail] = useState('');
    const [warning, setWarning] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (email === '' || !email.includes('@') || !email.includes('.')) {
            setWarning(1);
            return;
        }
        props.handleEmail(email);
        // console.log(email);
        props.setLoading(1);
        var response;
        try {

            const url = `https://haveibeenpwndedce.onrender.com/api/breachedaccount/${encodeURIComponent(email)}`;
            response = await axios.get(url);
            // setData(response.data);

            // console.log(response.data||response.data.error);
            console.log('res: ', response);
            props.setData(response.data);
            props.setLoading(0);

            if (response.data.heading) {
                document.querySelector('.breach-result-email').innerHTML = `<br>${props.email}<br>`;
            }
            navigate('/scan-details');
        } catch (error) {
            if (response?.status === 404 || (!response)) {
                props.setError(error?.response.data.error?.message || 'Internal Server Error');
                props.setLoading(-1);
                console.error('error: ', error);
                setWarning(-1);
            }
        }
    }

    return (
        <>
            <div className={classes.logo}>
                <img src="https://cyberethos.com.au/wp-content/uploads/2023/07/logo.jpg" alt="Have I Been Pwned" />
            </div>
            <div className={classes.home}>
                <div className={classes.svg}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-key-fill" viewBox="0 0 16 16">
                        <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-key-fill" viewBox="0 0 16 16">
                        <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                    </svg>
                </div>
                <form className={classes.scanner} onSubmit={handleSubmit}>
                    <label htmlFor="email"><span className={classes.yellowText}>Find out !</span> <span className={classes.whiteText}>If your personal information</span> <span className={classes.yellowText}>has been compromised</span></label>
                    <div className={classes.credentials}>
                        <input type="email" id="email" name="email" placeholder='Enter your email' onChange={(e) => setEmail(e.target.value)} />
                        {warning && <p className={classes.caution}>{warning===1?`Enter a valid email address`:props.error}</p>}
                        {props.loading === 1 ? <button className={classes.spinner}><Spin spinning={true} size='24' /></button> : <button type='submit'>Check Now</button>}
                    </div>
                </form>
            </div>
        </>
    );
}

export default HomePage;
